/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SmyFullPopup from '@/components/SmyFullPopup';
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import Search from "vux/src/components/search/index.vue"; // this line is trasformed by vux-loader
import MapFactory from '@/utils/map/MapFactory.js';
var map = {};
var marker = {};
var placeSearch = {};
var geocoder = {};
export default {
  name: 'mapView',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SmyFullPopup: SmyFullPopup,
    ViewBox: ViewBox,
    Search: Search
  },
  watch: {
    value: function value(val) {
      this.isShow = val;
    },
    isShow: function isShow(v) {
      var _this = this;
      if (v) {
        this.$setLeft({
          control: true,
          onSuccess: function onSuccess() {
            _this.isShow = false;
          }
        });
        this.getLocation();
      } else {
        this.$setLeft({
          control: false
        });
      }
      this.$emit('input', v);
    }
  },
  data: function data() {
    return {
      isShow: this.value,
      position: '',
      nowClickIndex: 0,
      isShowModal: false,
      madalLoading: true,
      center: [118.180987, 24.486432],
      nowAddress: '',
      searchKey: '',
      searchResult: [],
      cityList: [],
      selectCity: '',
      isClickMap: false
    };
  },
  mounted: function mounted() {
    this.loadmap();
  },
  methods: {
    getLocation: function getLocation() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var geo;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                geo = map.createGeolocation();
                geo.getCurrentPositionFix(function (status, res) {
                  var _res$addressComponent;
                  if (status !== 'complete') {
                    return;
                  }
                  var citycode = res === null || res === void 0 ? void 0 : (_res$addressComponent = res.addressComponent) === null || _res$addressComponent === void 0 ? void 0 : _res$addressComponent.citycode;
                  if (citycode) {
                    placeSearch.setCity(citycode);
                  }
                  _this2.center = [res.position.lng, res.position.lat];
                  marker = map.createMarker({
                    icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
                    position: _this2.center
                  });
                  map.clearMap();
                  map.addOverLay(marker);
                  map.panTo(_this2.center);
                  _this2.getNowAddress();
                  _this2.getNowCode(_this2.center.join(',')).then(function (res) {
                    if (res) {
                      _this2.seachAddress(res);
                    }
                  });
                });
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    callback: function callback(arr, add, name) {
      this.$emit('callback', {
        position: arr,
        address: add,
        name: name
      });
      this.isShow = false;
    },
    loadmap: function loadmap(code) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var citycode, center;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                citycode = code || i18n.tc("693");
                map = MapFactory.create('mymap');
                center = !_this3.center[0] || !_this3.center[1] ? [118.180987, 24.486432] : _this3.center;
                _context2.next = 5;
                return map.init({
                  resizeEnable: true,
                  center: center,
                  zoomEnable: true,
                  zoom: 13
                });
              case 5:
                // 实例化Geocoder
                geocoder = map.createGeocoder({
                  city: citycode
                });
                _this3.getNowAddress();
                map.on(map.map, 'click', function (e) {
                  _this3.isClickMap = true;
                  _this3.searchResult = [];
                  _this3.center = [e.lnglat.getLng(), e.lnglat.getLat()];
                  console.log('AutoConsole ~ this.center:', _this3.center);
                  marker = map.createMarker({
                    icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
                    position: _this3.center
                  });
                  map.clearMap();
                  map.addOverLay(marker);
                  marker.setPosition && marker.setPosition(_this3.center);
                  map.panTo(_this3.center);
                  _this3.getNowAddress();
                });
                placeSearch = map.createPlaceSearch({
                  city: citycode,
                  map: map.map
                });

              // map.on(placeSearch, 'click', (e) => {
              //   this.center = [e.data.location.lng, e.data.location.lat]
              //   marker.setPosition && marker.setPosition(this.center)
              //   map.panTo(this.center)
              //   this.getNowAddress()
              // })
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 根据地址获取地理编码
    getNowCode: function getNowCode(location) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, tips;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return map.reverseAddressFromLngLat(location[0], location[1]);
              case 2:
                res = _context3.sent;
                tips = res || '';
                return _context3.abrupt("return", tips);
              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    seachAddress: function seachAddress(addr) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var address;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                address = addr || _this4.position; // 关键字查询
                placeSearch.search(address, function (status, result) {
                  console.log('AutoConsole ~ result:', result);
                  if (result.info === 'OK' || result.info) {
                    if (result.poiList && result.poiList.pois) {
                      // let data = result.poiList.pois[0].location
                      _this4.searchResult = result.poiList.pois;
                      // this.center = [data.lng, data.lat]
                      // marker.setPosition && marker.setPosition(this.center)
                      // map.panTo(this.center)
                      // this.getNowAddress()
                    }
                  } else {
                    _this4.nowAddress = i18n.tc("694");
                    _this4.searchResult = [];
                  }
                });
              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    getNowAddress: function getNowAddress() {
      var _this5 = this;
      if (geocoder.getAddress) {
        // 地理编码返回详细地址
        geocoder.getAddress(this.center, function (status, result) {
          if (status === 'complete' && result.info === 'OK') {
            _this5.nowAddress = result.regeocode.formattedAddress;
          }
        });
      }
    }
  }
};